export const UNSELECTABLE_SX = {
  userSelect: "none",
  pointerEvents: "none",
};

export function getSafeImageOffsetSx(side: "left" | "right") {
  return {
    [side]: "-47%",
    "@media (min-width: 1280px)": { [side]: "-40%" },
    "@media (min-width: 1320px)": { [side]: "-30%" },
    "@media (min-width: 1420px)": { [side]: "-20%" },
    "@media (min-width: 1500px)": { [side]: "-10%" },
    "@media (min-width: 1590px)": { [side]: "0%" },
  };
}

export function getSafeImageOffsetSxForColumn(side: "left" | "right") {
  return {
    [side]: "-60%",
    "@media (min-width: 1280px)": { [side]: "-50%" },
    "@media (min-width: 1700px)": { [side]: "-55%" },
    "@media (min-width: 2000px)": { [side]: "-30%" },
  };
}
